module.exports = __webpack_public_path__ + "img/w3_question_white.3880156c.png";